module.exports = __webpack_public_path__ + "static/media/team-renee.532068fe.jpg";